import React, { useState, useEffect } from "react";
import "./styles.scss";
import 'animate.css';
import { Container, Row, Col, } from "reactstrap";
import { MyGallery } from "../..";
import Counter from '../../../components/screens/Counter/Counter'
import Mintbtn from "../../../components/screens/MinButtons";

const HomeMain = () => {
  const [state, setState] = useState(false)
  const launchDate = new Date("April 30, 2022 21:00:00");
  const now = new Date();
  now.setMinutes(now.getMinutes() + now.getTimezoneOffset());
  let launch = now >= launchDate ? true : false;

  return (
    <div className="main-wrapper">
      <Container>
        <br />
        <br />
        <br />
        <Row className="mt-4" id="/">
          <Col lg="7">
            <div className="main-detail">
              <p className="digital-crap">
                Deer + Predator NFTs
              </p>
              <br />
              <p className="poopies-detail">

                Dark Forest presents the Deer + Predator NFTs, the project’s
                first generation of NFTs within the Dark Forest ecosystem.
                Dark Forest NFTs are not only incredibly good looking,
                but possess top notch DeFi utilities. In the collection,
                investors will not find any identical NFTs. All NFTs are
                unique and one of a kind.
                The Dark Forest is their home and both prey and predator
                fight to keep it safe from evil forces lurking in the periphery of the Dark Forest.
                <br />
                <br />
                Within the forest, investors will find 4,995 deer (stags) divided
                into 4 tiers. Among them, 5 mythical predators lurk. These
                Predator NFTs are the most rare tier and by minting one, the
                investor will be rewarded with the highest level of weekly
                rewards as well as massive future ecosystem utility.

              </p>
              {/* <Mintbtn /> */}
              {launch ? <Mintbtn /> :
                <Counter />}
            </div>
          </Col>
          <Col lg="5">
            <div className="main-img">
              <img
                src="/images/giphy.gif"
                alt="img"
                className="giphyGIF"
              />
            </div>
          </Col>
        </Row>
      </Container>
      <MyGallery />
    </div>
  );
};

export default HomeMain;
